import { buildQueryString } from './queryParams';

export function navigateToAccountPages() {
  const queryString = buildQueryString();

  window.location.href = `/account/iwocapay/${queryString}`;
}
